import React, { useState } from "react";
import "./SingleLayerDropdown.css";
import CircularProgress from "@mui/material/CircularProgress";
import LayerInfoIcon from "../../atoms/layerInfoIcon/LayerInfoIcon.jsx";

const SingleLayerDropdown = ({
  title,
  description,
  items,
  opacities,
  onHandleOpacity,
  iconClass,
  panelType,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="dropdown-container"
      data-testid={`${panelType}-dropdown-${title}`}
    >
      <div className="dropdown-header-row">
        <button
          className={`dropdown-toggle-layers ${isOpen ? "openDrag" : ""}`}
          onClick={handleToggle}
          data-testid={`${panelType}-dropdown-toggle-${title}`}
          style={{ flex: 1 }}
        >
          {iconClass &&
            (typeof iconClass === "string" ? (
              <i
                className={iconClass}
                style={{ fontSize: "16px", marginRight: "8px" }}
              />
            ) : React.isValidElement(iconClass) ? (
              React.cloneElement(iconClass, {
                style: { fontSize: "16px", marginRight: "8px" },
              })
            ) : null)}
          {title}
        </button>
        <LayerInfoIcon
          description={description}
          testId={`${panelType}-dropdown-${title}`}
        />
      </div>
      <div
        className={`dropdown-content ${isOpen ? "open" : ""}`}
        data-testid={`${panelType}-dropdown-content-${title}`}
      >
        {items.map((item, index) => (
          <div
            key={index}
            data-testid={`${panelType}-layer-row-${item.name}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "3px 15px",
            }}
          >
            <div
              className={`dropdown-content-item ${
                item.disabled ? "dropdown-content-item-disabled" : ""
              }`}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "3px",
              }}
            >
              <input
                type="checkbox"
                className="custom-checkbox"
                data-testid={`${panelType}-layer-checkbox-${item.name}`}
                value={item.name}
                name={item.name}
                checked={item.showItem}
                disabled={item.disabled}
                onChange={(e) => {
                  if (item.disabled) return;
                  item.onChange(e);
                }}
              />
              <div
                data-testid={`${panelType}-layer-label-${item.name}`}
                onClick={() => {
                  if (item.disabled) return;
                  item.onChange({
                    target: { checked: !item.showItem, value: item.name },
                  });
                }}
                style={{
                  cursor: item.disabled ? "not-allowed" : "pointer",
                }}
              >
                {item.title}
              </div>
              {item.isLoading && <CircularProgress size={18} />}
            </div>

            {/* Conditionally render opacity slider only for non-3D items */}
            {item.name !== "3D" &&
              item.name !== "Carroyage DFCI" &&
              item.name !== "windDirection" &&
              item.name !== "majorRoads" &&
              item.name !== "railways" &&
              item.name !== "fireStations" &&
              item.name !== "arttificiel-water" &&
              item.name !== "Régions" &&
              item.name !== "Départements" && (
                <div
                  //className="dropdown-opacity-slider"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <input
                    type="range"
                    data-testid={`${panelType}-layer-opacity-slider-${item.name}`}
                    min="1"
                    max="100"
                    value={opacities[item.name] || 100}
                    disabled={item.disabled}
                    className={item.disabled ? "opacity-slider-disabled" : ""}
                    onMouseDown={(e) => e.stopPropagation()} // Prevent closing the dropdown
                    onChange={(e) =>
                      onHandleOpacity(item.name, Number(e.target.value))
                    }
                  />
                  <label
                    data-testid={`${panelType}-layer-opacity-value-${item.name}`}
                  >
                    {opacities[item.name] || 100}%
                  </label>
                </div>
              )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(SingleLayerDropdown);
